/* Header Glow — place at: assets/header-glow.js */

(function () {
  document.querySelectorAll('.header-glow').forEach(function (header) {
    var toggle = header.querySelector('[data-header-glow-mobile-toggle]');
    var panel = header.querySelector('[data-header-glow-mobile-panel]');

    if (!toggle || !panel) return;

    toggle.addEventListener('click', function () {
      panel.classList.toggle('is-open');
      var expanded = panel.classList.contains('is-open');
      toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    });
  });
})();
